export const dummyTx = () => {
  let tx = '';
  const chars = 'AaBbCcDdEeFf0123456789';
  const charsLength = chars.length;
  for (let i = 0; i < 62; i++) {
    tx += chars.charAt(Math.floor(Math.random() * charsLength));
  }
  return `0x${tx.toLowerCase()}`;
};
